<template>


  <div v-if="options" :class="col">
    <label class="bold-600" v-if="label" :for="id">
      {{ label }}
      <span v-if="required" class="required-input" :class="{'error-input' : $v.content.$error}">* </span>
      <a v-if="tooltip" v-tooltip="{content: tooltip, trigger: 'click' }">
        <i class="fa fa-question-circle-o"></i>
      </a>
    </label>
    <div class="control-select">
      <select v-if="options.length > 3" v-model="content" :name="id" @change="updateValue"
              :id="id" :required="required" :class="{'border border-danger' : $v.content.$error}">

         <option selected disabled hidden value="">{{ placeholder }}</option>

        <option v-for="option in options" v-bind:value="option.value" :key="option.value">
          {{ option.text }}
        </option>
      </select>
      <div v-if="options.length > 3" class="select-arrow"></div>
      <template v-else v-for="option in options">
        <div :key="option.value" class="form-checkboxes form-display-inline">
          <input @change="updateValue" type="radio" :id="id+option.value" :value="option.value" v-model="content" :name="id+option.value" :required="required" />
          <label :for="id+option.value" :class="{'text-danger' : $v.content.$error}">{{ option.text }}</label>
        </div>
      </template>
    </div>
    <!--
    <template v-if="$v.content.$error && $v.content.required === false">
      <small class="" >Pflichtangabe</small>
    </template>
  -->
  </div>

  <div v-else :class="col">
<!--    {{ $v.content }}-->
    <div class="form-checkboxes form-display-inline">
      <input type="checkbox" :id="id"
             v-model="content" :name="id" @change="updateValue" :required="required" />
      <label v-if="label" :for="id" v-html="label" :class="{'text-danger' : $v.content.$error}" />
      <label v-else :for="id" :class="{'text-danger' : $v.content.$error}">
        <template v-if="isDS || (!isDS && !isWR)">
          Ich habe die Bestimmungen zum <a class="text-secondary" href="#" v-b-modal.modal-datenschutzerklaerung>Datenschutz</a> zur Kenntnis genommen und erkläre mich damit einverstanden.
        </template>
        <template v-if="(isDS && isWR) || (!isDS && !isWR)">
          Ich habe die <a class="text-secondary" href="#" v-b-modal.modal-datenschutzerklaerung>Datenschutzerklärung</a> und <a class="text-secondary" href="#" v-b-modal.modal-widerrufsbelehrung>Widerrufsbelehrung</a> zur Kenntnis genommen und bin damit einverstanden.
        </template>
        <template v-if="isWR || (!isDS && !isWR)">
          Hiermit bestätige ich die <a class="text-secondary" href="#" v-b-modal.modal-widerrufsbelehrung>Widerrufsbelehrung</a> gelesen und verstanden zu haben. Ich willige ein, dass mit der Ausführung des Auftrags sofort begonnen werden kann. Darüber hinaus bin ich mir im Klaren, dass ich mein Widerrufsrecht bei vollständiger Vertragserfüllung durch die Kanzlei VON RUEDEN Partnerschaft von Rechtsanwälten verliere.
        </template>
      </label>
      <!--<template v-if="$v.content.$error && $v.content.required === false">
        <small class="" >Pflichtangabe</small>
      </template>
    -->
    </div>

    <datenschutzerklaerung v-if="!label && (isDS || (!isDS && !isWR))"/>
    <widerrufsbelehrung v-if="!label && (isWR || (!isDS && !isWR))"/>
  </div>


  <!-- Layout mit Knöpfen "neben" der Frage entsprechen nicht der normalen systematik undreihfolge untereinander (Jan), daher entfernt -->
<!--  <div v-else-if="label" class="row">-->
<!--    <div class="col-12 col-md-7 col-xl-8 pr-0">-->
<!--      <p v-if="label" class="form-question">-->
<!--        {{ label }}-->
<!--      </p>-->
<!--    </div>-->
<!--    <div class="col-12 col-md-5 col-xl-4 text-right mobile-md-text-left">-->
<!--      <template v-for="option in options">-->
<!--        <div :key="option.value" class="form-checkboxes form-display-inline">-->
<!--          <input type="radio"-->
<!--                 :id="option.value"-->
<!--                 :value="option.value"-->
<!--                 v-model="content"-->
<!--                 :name="id"-->
<!--                 @change="updateValue"-->
<!--                 required/>-->
<!--          <label :for="option.value">{{ option.text }}</label>-->
<!--        </div>-->
<!--      </template>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div v-else class="row">-->
<!--    <div v-if="label" class="col-12">-->
<!--      <p class="form-question">-->
<!--        {{ label }}-->
<!--      </p>-->
<!--    </div>-->
<!--    <div class="col-12">-->
<!--      <template v-for="option in options">-->
<!--        <div :key="option.value" class="form-checkboxes form-display-inline">-->
<!--          <input @change="updateValue" type="radio" :id="option.value" :value="option.value" v-model="content" :name="id" required/>-->
<!--          <label :for="option.value" class="">{{ option.text }}</label>-->
<!--        </div>-->
<!--      </template>-->
<!--    </div>-->
<!--  </div>-->

</template>
<script>

import General from '@/mixins/general';
import axios from "axios";
import Datenschutzerklaerung from "@/views/Datenschutzerklaerung";
import Widerrufsbelehrung from "@/views/Widerrufsbelehrung";
import {required, sameAs} from "vuelidate/lib/validators";

export default {
  mixins: [General],
  components: {Widerrufsbelehrung, Datenschutzerklaerung},
  props: {
    value: [String,Boolean],
    label: String,
    placeholder: String,
    uri: String,
    list: {
      type: Array,
      default: null,
    },
    col: {
      type: String,
      default: 'col-12 col-md-12'
    },
    isDS: Boolean,
    isWR: Boolean,
    required: {
      type: Boolean,
      default: false
    },
    tooltip: String
  },
  data: function () {
    return {
      options: null,
      content: this.value,
      id: "select_"+this._uid
    }
  },
  validations() {
    let rules = { content: {} };
    if (this.required) {
      rules.content = {...rules.content, ...{ required }};
      if (!this.options) rules.content = {...rules.content, ...{ sameAs: sameAs( () => true )  }};
    }
    return rules;
  },
  mounted() {
    if (this.$v.content.$invalid) {
      this.changeErrorCount(true);
      // console.log("+1",this.label + " erstellt");
    }
    this.setList();
    this.content = this.value;
    this.id = "select_"+this._uid;
  },
  methods: {
    updateValue() {
      this.$v.content.$touch();
      this.$emit('input', this.content);
      if (this.options) {
        this.sendGaEvent(this.label ? this.label : this.options.reduce((r, obj) => r.text+"/"+obj.text));
      } else {
        let frage = "";
        if (this.isDS || (!this.isDS && !this.isWR)) frage += "Datenschutzerklärung";
        if (this.isDS && this.isWR) frage += " und ";
        if (this.isWR || (!this.isDS && !this.isWR)) frage += "Widerrufsbelehrung";
        this.sendGaEvent(this.label ? this.label : frage);
      }
    },
    setList() {
      if (this.uri) {
        return axios.get(this.uri)
            .then(response => {
              this.options = response.data;
            });
      } else if (this.list) {
        this.options = this.list;
      } else {
        this.options = null;
      }
    },
  },
  watch: {
    $global: function (newV) {
      if (newV.showAllInputError) {
        this.$v.content.$touch();
      }
    },
    '$v.content.$invalid': function (newV) {
      this.changeErrorCount(newV);
      // console.log(newV ? "+1" : "-1",this.label + " geändert");
    },
  },
  destroyed() {
    if (this.$v.content.$invalid) {
      this.changeErrorCount(false);
      // console.log("-1",this.label + " destroyed");
    }
  }
}
</script>
